module.exports = __webpack_public_path__ + "static/img/audio.6c2a12e7.png";